module.exports = __webpack_public_path__ + "static/media/v31.ded8a26a.mp4";